/* lua.js generated code 0.3.0 */

var AddressButton = xClass("AddressButton", function () {
    // return cc.CSLoader.createNode("cocos/homeScene_coupon_btn.csb")
    return cc.Sprite.createWithSpriteFrameName("commonLib/address_btn.png");
    // return cc.Node.create()
})
AddressButton.prototype.ctor = function () {
    let self = this
    self.init()
}
AddressButton.prototype.init = function () {
    var self = this
    var btn = UIButton.create(self, true)
    btn.on(UIButtonEvent.Click, handler(self, self.onOpenAddress))
    self.btn = btn
}

AddressButton.prototype.onOpenAddress = function () {
    var self = this
    // require("clover/panel/SettingPanel").create().popup(true)
    if (self.isBusy){
        return
    }
    self.isBusy = true
    ActivityAddressPanel.show(()=>{
        self.isBusy = false
    })
}


module.exports = AddressButton
